import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';
import { ClientRegistrationRequest } from '../models/requests/client-registration-request';
import { ResetPasswordRequest } from '../models/requests/reset-password-request';
import { UserResponse } from '../models/responses/user-response';
import { UpdateUserInfoRequest } from '../models/requests/update-user-info-request';
import { ApiKeyResponse } from '../models/responses/api-key-response';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) { }

  createUser(request: ClientRegistrationRequest) {
    return this.httpClient.post<any>(`${environment.userUrl}/create`, request);
  }

  updateUserInfo(request: UpdateUserInfoRequest) {
    return this.httpClient.put<UserResponse>(`${environment.userUrl}/updateUserInfo`, { request });
  }

  createSubaccountUser(request: ClientRegistrationRequest) {
    return this.httpClient.post<any>(`${environment.userUrl}/create/subAccountUser`, request);
  }

  fetchLoggedUser() {
    return this.httpClient.get<UserResponse>(`${environment.userUrl}`);
  }

  createApiKey() {
    return this.httpClient.post<ApiKeyResponse[]>(`${environment.userUrl}/apiKey/create`, {})
  }

  deleteApiKey(id: number) {
    return this.httpClient.delete<ApiKeyResponse[]>(`${environment.userUrl}/apiKey/${id}`);
  }

  fetchAllUsersForAdmin() {
    return this.httpClient.get<UserResponse[]>(`${environment.userUrl}/fetchAllUsersForAdmin`);
  }

  validateAccount(linkId: string) {
    return this.httpClient.post<any>(`${environment.userUrl}/validateAccount`, { linkId });
  }

  resetPassword(request: ResetPasswordRequest) {
    return this.httpClient.post<string>(`${environment.userUrl}/resetPassword`, request);
  }
}
